import { Group, Stack } from '@mantine/core';
import { randomId } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons-react';
import FormInputGroup from 'components/forms/FormInputGroup';
import SpecialFieldPairingRow from 'components/forms/remote-source/config/chastia-config-form/special-fields/SpecialFieldPairingRow';
import { ChastiaConfigForm } from 'components/forms/remote-source/config/types';
import P2Medium from 'components/typography/P2Medium';
import Button from 'components/Button';

interface SpecialFieldsProps {
  form: ChastiaConfigForm;
}

/**
 * Sub-form for Chastia special field pairings.
 */
export default function SpecialFields({ form }: SpecialFieldsProps) {
  const specialFields = form.values.specialFields ?? [];

  return (
    <FormInputGroup groupTitle="Špeciálne polia">
      <Stack spacing={8}>
        <Group className="grid max-w-[972px] grid-cols-[1fr_24px_1fr_44px] items-center gap-y-0">
          <P2Medium>Špeciálne pole</P2Medium>
          <div></div>
          <P2Medium>Evidenčné pole</P2Medium>
        </Group>

        {specialFields.map((item, index) => (
          <SpecialFieldPairingRow key={item.key} form={form} item={item} index={index} />
        ))}

        <Group mt={8}>
          <Button
            size="md"
            leftIcon={<IconPlus />}
            onClick={() => form.insertListItem('specialFields', { key: randomId() })}
          >
            Pridať riadok
          </Button>
        </Group>
      </Stack>
    </FormInputGroup>
  );
}
